<template>
  <section :class="$style.container">
    <Wrapper :class="$style.inner">
      <Title :title-params="primary.title" :class="$style.title" />
      <ul :class="$style.itemsContainer">
        <li
          v-for="(tweet, tweetIndex) in items"
          :key="tweetIndex"
          :class="[$style.card, { [$style.clickable]: tweet.tweet_url }]"
          @click="onClickTweet($event, tweet)"
        >
          <TwitterIcon height="24px" width="24px" />
          <RichText :text-params="tweet.tweet" />
          <figure :class="$style.infoContainer">
            <PImage
              :image-object="tweet.profile_picture"
              :class="$style.profileImage"
              sizes="xs:100px"
            />
            <div :class="$style.info">
              <Title :title-params="tweet.name" :class="$style.name" />
              <RichText
                :text-params="tweet.twitter_handle"
                :class="$style.sub"
              />
            </div>
          </figure>
        </li>
      </ul>
    </Wrapper>
    <TestimonialVideo :slice="slice" />
  </section>
</template>

<script>
import TwitterIcon from 'LkIcons/SocialTwitter.vue'

import TestimonialVideo from './components/TestimonialVideo.vue'

export default {
  name: 'TwitterTestimonials',
  components: {
    TestimonialVideo,
    TwitterIcon,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
    }
  },
  methods: {
    onClickTweet(event, tweet) {
      const url = tweet?.tweet_url
      if (url && event?.target?.tagName !== 'A') {
        const win = window.open(url, '_blank')
        win.focus()
      }
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  justify-content: space-between;
  padding: 160px 32px 64px;

  background: white;
}

.title {
  margin-bottom: 48px;

  font-weight: 200;
  font-size: 48px;
  line-height: 55px;
  text-align: center;
}

.itemsContainer {
  display: flex;
  gap: 32px;
  justify-content: center;
  @include below(medium) {
    flex-direction: column;
    align-items: center;
  }
}

.card {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 30px;
  justify-content: space-between;
  box-sizing: border-box;
  max-width: 320px;
  padding: 24px;
  border: 1px solid $gray-100;
  border-radius: 8px;
}

.profileImage {
  width: 32px;
  height: 32px;
}

.infoContainer {
  display: flex;
}
.info {
  margin-left: 8px;
}

.name h3 {
  margin-bottom: 0 !important;

  color: $gray-700;
  font-size: 12px;
  line-height: 16px;
}
.sub {
  color: $gray-500;
  font-size: 12px;
  line-height: 16px;
}

.clickable {
  cursor: pointer;
}
</style>
